// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"confirm-account_wrapper__3CwPe"};